/**
 * Arabic Products Translations
 * 产品页翻译模块 - 阿拉伯语
 *
 * 包含产品列表、产品详情、五个产品完整翻译
 */

import type { ProductsTranslations } from '../../types';

export const arProducts: ProductsTranslations = {
  title: 'جميع المنتجات',
  subtitle: 'اكتشف حل التدفئة المثالي لمساحتك',
  viewDetails: 'عرض التفاصيل',
  header: {
    title: 'جميع المنتجات',
    subtitle: 'اكتشف حل التدفئة المثالي لمنزلك أو مكتبك أو مساحتك الصناعية.',
  },
  filters: {
    all: 'الكل',
    searchPlaceholder: 'البحث عن المنتجات...',
  },
  catalog: 'تحميل الكتالوج الكامل',
  discoverMore: 'اكتشف المزيد',
  viewSpecs: 'عرض المواصفات',
  categories: {
    infraredHeater: 'سخان بالأشعة تحت الحمراء',
    portableHeater: 'سخان محمول',
    gasHeater: 'مدافئ الغاز الخارجية',
  },
  navDesc: {
    infrared: 'ألواح إشعاعية للجدران والأسقف',
    portable: 'أرضية وطاولة ومعلّقة',
    gas: 'مدافئ وطاولات نار',
  },
  viewAllProducts: 'عرض جميع المنتجات',
  gasSubtitle: 'مدافئ غاز وطاولات نار للتراسات والمساحات الخارجية.',
  categoryLanding: {
    gas: {
      title: 'مدافئ الغاز الخارجية وطاولات النار',
      subtitle:
        'تدفئة في الهواء الطلق من 8 كيلوواط إلى 50,000 وحدة حرارية، مع مشاعل من الستانلس ستيل 304 وواقيات زجاجية ضد الرياح وإعدادات غاز البترول المسال وفق سوقك المستهدف.',
      empty: 'لا توجد منتجات في هذه الفئة.',
    },
    infrared: {
      title: 'سخانات بالأشعة تحت الحمراء',
      subtitle: 'حرارة إشعاعية مصممة لتدفئة فعّالة وموجّهة—مثالية للشرفات والورش ومناطق الراحة.',
      empty: 'لم يتم العثور على منتجات في هذه الفئة.',
    },
    portable: {
      title: 'سخانات محمولة',
      subtitle: 'حلول تدفئة مرنة للمنزل والعمل—سهلة النقل، سريعة الإحماء، ومناسبة للراحة اليومية.',
      empty: 'لم يتم العثور على منتجات في هذه الفئة.',
    },
  },
  detail: {
    technicalSpecs: 'المواصفات الفنية',
    relatedProducts: 'منتجات {{category}} ذات صلة',
    requestQuote: 'طلب عرض سعر',
    backToProducts: 'العودة للمنتجات',
    productNotFound: 'المنتج غير موجود',
    specsAvailableOnRequest: 'المواصفات متاحة عند الطلب.',
    noMatchingProducts: 'لا توجد منتجات مطابقة',
    noProducts: 'لا توجد بيانات المنتجات',
  },
  items: {
    p1: {
      name: 'سلسلة 13A',
      description: 'سخان بالأشعة تحت الحمراء البعيدة موفر للطاقة بخيارات قدرة متعددة، مثالي للاستخدام الداخلي والخارجي في الشرفات والمطاعم والورش.',
      longDescription:
        'سلسلة 13A هي سخان بالأشعة تحت الحمراء البعيدة عالي الأداء مصمم للتدفئة الإشعاعية الفعّالة في المساحات الداخلية والخارجية. يوفر كفاءة طاقة تصل إلى 99٪ مع استهلاك أقل بنسبة 80٪ مقارنة بالتدفئة التقليدية. مثالي للشرفات والمطاعم والمقاهي والورش والمستودعات، مع لوحة تسخين مقوسة تضمن تغطية حرارية واسعة. يمكن تركيبه على الحائط لتوفير المساحة، ويعمل بهدوء تام دون ضوضاء أو جفاف، مما يجعله الخيار الأمثل للتدفئة الإشعاعية المريحة.',
      category: 'سخان بالأشعة تحت الحمراء',
      features: ['صديق للبيئة', 'آمن وهادئ', 'عمر طويل', '350°C حرارة عالية'],
      specs: [
        { label: 'الموديل', value: 'NR10/18/24/32/40-13A' },
        { label: 'القدرة', value: '2400W' },
        { label: 'منطقة التغطية', value: '30 m²' },
        { label: 'الجهد/التردد', value: '230V, 50/60Hz' },
        { label: 'التيار المقنن', value: '10.4A' },
        { label: 'درجة حرارة السطح', value: '300°C' },
        { label: 'الأبعاد', value: '1500×189×67mm' },
        { label: 'الوزن الصافي/الإجمالي', value: '8.8/10.6 kg' },
      ],
    },
    p2: {
      name: 'سلسلة 13B',
      description: 'سخان بالأشعة تحت الحمراء البعيدة موفر للطاقة مع تحكم عن بعد ومؤشر LED، مناسب للتدفئة الداخلية والخارجية في المطاعم والشرفات.',
      longDescription:
        'سلسلة 13B هي سخان بالأشعة تحت الحمراء البعيدة بكلاسيكي خفيف وأداء عالٍ في توفير الطاقة. يوفر تدفئة إشعاعية فعّالة مع كفاءة تحويل كهربائي حراري تصل إلى 99٪. مجهز بمنظم حرارة وتحكم عن بعد مع مؤشر LED لسهولة التشغيل. مناسب للاستخدام الداخلي والخارجي في المطاعم والمقاهي والشرفات والورش، مع لوحة تسخين مقوسة تضمن تغطية حرارية واسعة ومتساوية.',
      category: 'سخان بالأشعة تحت الحمراء',
      features: ['تحكم عن بعد', 'مؤشر LED', 'صديق للبيئة', 'كفاءة عالية', 'سطح 300°C'],
      specs: [
        { label: 'الموديل', value: 'NR10/18/24/32-13B' },
        { label: 'القدرة', value: '2400W' },
        { label: 'منطقة التغطية', value: '30 m²' },
        { label: 'الجهد/التردد', value: '230V, 50/60Hz' },
        { label: 'التيار المقنن', value: '10.4A' },
        { label: 'درجة حرارة السطح', value: '300°C' },
        { label: 'الأبعاد', value: '1500×189×67mm' },
        { label: 'الوزن الصافي/الإجمالي', value: '8.8/10.6 kg' },
      ],
    },
    p3: {
      name: 'سلسلة 13C',
      description: 'سخان بالأشعة تحت الحمراء البعيدة مع سماعة بلوتوث مدمجة، مثالي للمساحات الخارجية وشبه المفتوحة مثل الشرفات والمطاعم والمقاهي.',
      longDescription:
        'سلسلة 13C هي سخان بالأشعة تحت الحمراء البعيدة مبتكر مصمم للمساحات الخارجية وشبه المفتوحة، مع سماعة بلوتوث مدمجة لتشغيل الموسيقى أثناء التدفئة الإشعاعية الفعّالة. يوفر 4 مستويات طاقة (25٪ و50٪ و75٪ و100٪) مع كفاءة طاقة عالية. لوحة التسخين مطلية بطبقة نانو خاصة لتحسين انبعاث الأشعة تحت الحمراء. مثالي للمطاعم والمقاهي والشرفات والبلاطات، حيث يجمع بين التدفئة المريحة والترفيه الصوتي بهدوء تام.',
      category: 'سخان بالأشعة تحت الحمراء',
      features: ['سماعة بلوتوث', '4 مستويات طاقة', 'راحة بالأشعة تحت الحمراء', 'صوت عبر البلوتوث', 'تشغيل صامت'],
      specs: [
        { label: 'الموديل', value: 'NR10/18/24/32-13C' },
        { label: 'القدرة', value: '1800W' },
        { label: 'منطقة التغطية', value: '20 m²' },
        { label: 'الجهد/التردد', value: '230V, 50/60Hz' },
        { label: 'التيار المقنن', value: '7.8A' },
        { label: 'درجة حرارة السطح', value: '300°C' },
        { label: 'الأبعاد', value: '1370×189×67mm' },
        { label: 'الوزن الصافي/الإجمالي', value: '8.3/10.2 kg' },
        { label: 'حاوية التحميل', value: '705/1632; 480/1156; 355/884; 270/612' },
      ],
    },
    p4: {
      name: 'سلسلة 22B',
      description: 'سخان بالأشعة تحت الحمراء البعيدة بلوح زجاجي سيراميكي فاخر مع تحكم WiFi Tuya، مثالي للتدفئة الإشعاعية الداخلية والخارجية.',
      longDescription:
        'سلسلة 22B هي سخان بالأشعة تحت الحمراء البعيدة فاخر بلوحات تسخين زجاجية سيراميكية تسخن بسرعة وبشكل متساوٍ مع مقاومة حرارية تصل إلى 950°C. يوفر تدفئة إشعاعية نظيفة وموفرة للطاقة بدون ضوضاء أو جفاف. مجهز بتحكم عن بعد وتطبيق WiFi Tuya لتشغيل مريح من الهاتف. مناسب للاستخدام الداخلي والخارجي في المطاعم والمقاهي والشرفات والورش. يجمع بين التصميم الحديث والأداء العالي مع كفاءة طاقة ممتازة.',
      category: 'سخان بالأشعة تحت الحمراء',
      features: ['تطبيق WiFi Tuya', 'تحكم عن بعد', 'لوح زجاجي سيراميكي', 'تسخين سريع', 'العناية الصحية'],
      specs: [
        { label: 'الموديل', value: 'NR16/22/32-22B' },
        { label: 'القدرة', value: '1.6/2.2/3.2 kW' },
        { label: 'مساحة التغطية', value: '20/30/40 m²' },
        { label: 'الجهد/التردد', value: '220-240V~50/60Hz' },
        { label: 'التيار المقنن', value: '7/9.6/13.9A' },
        { label: 'درجة حرارة السطح', value: '380°C' },
        { label: 'الأبعاد', value: '810/1160/1660 × 180 × 77 mm' },
        { label: 'الوزن الصافي/الإجمالي', value: '5/6.1; 7/8.2; 9.9/11.7 kg' },
        { label: 'حمولة الحاوية', value: '728/1638; 507/1162; 377/826' },
      ]
    },
    p5: {
      name: 'سلسلة 13W',
      description: 'سخان ذكي بالأشعة تحت الحمراء البعيدة مقاوم للماء بتصنيف IPX4 مع تحكم WiFi Tuya، مناسب للاستخدام الداخلي والخارجي في الشرفات والمطاعم.',
      longDescription:
        "تجمع سلسلة 13W بين تطبيق Tuya عبر WiFi وجهاز تحكم LCD وشاشة LED وأربعة مستويات للطاقة. تناسب الغرف والمناطق المغطاة ذات الجدار المناسب، مع حوامل متوافقة والخلوص المحدد للطراز. تشير IPX4 إلى حماية من رذاذ الماء.",
      category: 'سخان بالأشعة تحت الحمراء',
      features: ['تطبيق WiFi Tuya', 'شاشة LED', 'تحكم عن بعد LCD', '4 مستويات طاقة', 'IPX4 مقاوم للماء'],
      specs: [
        { label: 'الموديل', value: 'NR10/18/24/32-13W' },
        { label: 'القدرة', value: '1.0/1.8/2.4/3.2 kW' },
        { label: 'مساحة التغطية', value: '10/20/30/40 m²' },
        { label: 'الجهد/التردد', value: '220-240V~50/60Hz' },
        { label: 'التيار المقنن', value: '4.3/7.8/10.4/13.9A' },
        { label: 'درجة حرارة السطح', value: '300°C' },
        { label: 'الأبعاد', value: '755/1150/1655/2155 × 189 × 67 mm' },
        { label: 'الوزن الصافي/الإجمالي', value: '4.4/5.5; 6.9/8.1; 9.5/11.3; 12.3/14.3 kg' },
        { label: 'حمولة الحاوية', value: '840/1680/2100; 530/1080/1350; 570/900/980; 350/700/800' },
      ]
    },
    p6: {
      name: 'سلسلة 14A',
      description: 'سخان بالأشعة تحت الحمراء البعيدة بتصميم قوس كلاسيكي مع تصنيف IPX4 للمقاومة الماء، مثالي للتدفئة الإشعاعية في الشرفات والمطاعم والورش.',
      longDescription:
        "تستخدم سلسلة 14A لوحة مقوسة بطبقة نانوية بقدرات من 1000W إلى 4000W دون وحدة تحكم مدمجة. يُختار جدار مناسب داخل المبنى أو في منطقة مغطاة، وتُؤكد الحوامل والخلوص وتجهيزات التحكم للطراز. تشير IPX4 إلى حماية من رذاذ الماء.",
      category: 'سخان بالأشعة تحت الحمراء',
      features: ['تصميم القوس', 'قدرة متعددة', 'IPX4 مقاوم للماء', 'تسخين سريع', 'كفاءة الطاقة'],
      specs: [
        { label: 'الموديل', value: '' },
        { label: 'القدرة', value: '' },
        { label: 'مساحة التغطية', value: '' },
        { label: 'الجهد/التردد', value: '' },
        { label: 'التيار المقنن', value: '' },
        { label: 'درجة حرارة السطح', value: '' },
        { label: 'الأبعاد', value: '' },
        { label: 'الوزن الصافي/الإجمالي', value: '' },
        { label: 'حمولة الحاوية', value: '' },
      ]
    },
    p7: {
      name: 'سلسلة 14B',
      description: "سخان أشعة تحت الحمراء جداري بتحكم عن بعد للغرف والشرفات المغطاة ذات الجدار المناسب.",
      longDescription:
        "تجمع سلسلة 14B بين لوحة مقوسة بطبقة نانوية وتحكم عن بعد ومؤشر LED وأربعة مستويات للطاقة ومؤقت 0/2/4/6/8 ساعات. تُثبت على جدار مناسب داخل المبنى أو في منطقة مغطاة بحوامل متوافقة والخلوص المحدد. نحافة الهيكل لا تثبت ملاءمته لهياكل تركيب أخرى.",
      category: 'سخان بالأشعة تحت الحمراء',
      features: ['تحكم عن بعد', 'وظيفة المؤقت', 'تصميم القوس', 'IPX4 مقاوم للماء', 'تسخين سريع'],
      specs: [
        { label: 'الموديل', value: '' },
        { label: 'القدرة', value: '' },
        { label: 'مساحة التغطية', value: '' },
        { label: 'الجهد/التردد', value: '' },
        { label: 'التيار المقنن', value: '' },
        { label: 'درجة حرارة السطح', value: '' },
        { label: 'الأبعاد', value: '' },
        { label: 'الوزن الصافي/الإجمالي', value: '' },
        { label: 'حمولة الحاوية', value: '' },
      ]
    },
    p8: {
      name: 'سلسلة 23W',
      description: 'سخان أشعة تحت الحمراء فائق النحافة مع تطبيق Tuya Smart عبر WiFi وتحكم صوتي وجهاز تحكم ومؤقت للمساحات الداخلية والشرفات المغطاة.',
      longDescription:
        "تجمع سلسلة 23W بين لوحة سوداء نحيفة بطبقة نانوية وتطبيق Tuya Smart عبر WiFi وأوامر صوتية متوافقة. يوفر جهاز التحكم أربعة مستويات للطاقة ومؤقت 0/2/4/6/8 ساعات. تُثبت على جدار مناسب في منطقة داخلية أو مغطاة بحوامل وخلوص متوافقين مع الطراز.",
      category: 'سخان بالأشعة تحت الحمراء',
      features: ['تطبيق Tuya Smart', 'تحكم صوتي', 'تحكم عن بعد', 'وظيفة المؤقت', '4 مستويات طاقة', 'تسخين سريع'],
      specs: [
        { label: 'الموديل', value: 'NR10/18/24/32-23W' },
        { label: 'القدرة', value: '1.0/1.8/2.4/3.2 kW' },
        { label: 'مساحة التغطية', value: '10/20/30/40 m²' },
        { label: 'الجهد/التردد', value: '220-240V~50/60Hz' },
        { label: 'التيار المقنن', value: '4.3/7.8/10.4/13.9A' },
        { label: 'درجة حرارة السطح', value: '300°C' },
        { label: 'الأبعاد', value: '693/1093/1593/2093 × 151 × 52 mm' },
        { label: 'الوزن الصافي/الإجمالي', value: '3.4/4.2; 5.3/6.4; 7.6/9.5; 9.9/12.5 kg' },
        { label: 'حمولة الحاوية', value: '1248; 800; 528; 412 (20HQ)' },
      ]
    },
    p20: {
      name: 'سلسلة 23A',
      description: 'سخان أشعة تحت حمراء فائق النحافة مع جهاز تحكم تقليدي ومؤقت و4 مستويات للطاقة، بلا WiFi أو تطبيق.',
      longDescription:
        'سلسلة 23A سخان أشعة تحت حمراء فائق النحافة يعمل بجهاز تحكم تقليدي، من دون اتصال WiFi أو تطبيق. يوفر جهاز التحكم 4 مستويات للطاقة (25٪/50٪/75٪/100٪) ومؤقت 0/2/4/6/8 ساعات. تمنح اللوحة السوداء ذات الطلاء النانوي حرارة إشعاعية سريعة ومتساوية وهادئة ومن دون لهب. تتوفر قدرات من 1000W إلى 3200W لمساحات 10-40 م²، ويجعل السمك 52 ملم السخان مناسباً للمنازل والمطاعم والمكاتب والشرفات المغطاة.',
      category: 'سخان بالأشعة تحت الحمراء',
      features: ['تحكم عن بعد', 'وظيفة المؤقت', '4 مستويات طاقة', 'موفر للطاقة', 'تسخين سريع', 'تشغيل هادئ'],
      specs: [
        { label: 'الموديل', value: '' },
        { label: 'القدرة', value: '' },
        { label: 'مساحة التغطية', value: '' },
        { label: 'الجهد/التردد', value: '' },
        { label: 'التيار المقنن', value: '' },
        { label: 'درجة حرارة السطح', value: '' },
        { label: 'الأبعاد', value: '' },
        { label: 'الوزن الصافي/الإجمالي', value: '' },
        { label: 'حمولة الحاوية', value: '' },
      ]
    },
    p21: {
      name: 'سلسلة 25W',
      description: 'سخان جداري بالأشعة تحت الحمراء البعيدة مع WiFi مدمج وتحكم بتطبيق Tuya وشاشة LED للمستوى، وأربع درجات طاقة من 1000 واط إلى 3200 واط.',
      longDescription:
        'سلسلة 25W هي سخان جداري نحيف بالأشعة تحت الحمراء البعيدة، مزوّد بوحدة WiFi مدمجة للتحكم عبر تطبيق Tuya Smart: شغّل اللوحة وغيّر مستوى الطاقة واضبط الجداول من هاتفك، أو استخدم جهاز التحكم اللاسلكي المُرفق بزر اقتران WiFi. تعرض شاشة LED الحمراء على صندوق التحكم مستوى الطاقة الحالي. تمتد أربع درجات طاقة من 1000 واط إلى 3200 واط وتغطي من 10 م² إلى 40 م²، وتتشاطر جميع الطُرز الجسم الألمنيوم نفسه بسمك 67 مم. يمتد عنصر تسخين حلزوني بالأشعة تحت الحمراء البعيدة على كامل اللوحة داخل جسم من الألمنيوم المبثوق فيرفع حرارة السطح المضلّع المصنوع من الألمنيوم إلى 300 درجة مئوية.',
      category: 'سخان بالأشعة تحت الحمراء',
      features: ['تطبيق WiFi Tuya', 'شاشة LED للمستوى', 'تحكم لاسلكي', '4 مستويات طاقة', 'سطح 300 °م', 'جسم نحيف 67 مم'],
      specs: [
        { label: 'الموديل', value: 'NR10/18/24/32-25W' },
        { label: 'القدرة', value: '1.0/1.8/2.4/3.2 kW' },
        { label: 'مساحة التغطية', value: '10/20/30/40 m²' },
        { label: 'الجهد/التردد', value: '220-240V~50/60Hz' },
        { label: 'التيار المقنن', value: '4.3/7.8/10.4/13.9A' },
        { label: 'درجة حرارة السطح', value: '300°C' },
        { label: 'الأبعاد', value: '715/1115/1615/2115 × 189 × 67 mm' },
        { label: 'الوزن الصافي/الإجمالي', value: '4.4/5.5; 6.9/8.1; 9.5/11.3; 12.3/14.3 kg' },
        { label: 'حمولة الحاوية', value: '945/1920/2176; 615/1290/1462; 435/885/1003; 345/705/799' },
      ]
    },
    p9: {
      name: 'JHL020A',
      description: 'سخان ألياف كربونية مدمج مع حماية من الانقلاب. مثالي للتدفئة الشخصية تحت المكاتب أو الطاولات.',
      longDescription:
        'JHL020A هو سخان طاولة مدمج وفعال مصمم للتدفئة الشخصية. يتميز بأنبوب تسخين من الألياف الكربونية للتوزيع السريع والمتساوي للحرارة. مجهز بتحكم بمفتاح تبديل وحماية من الانقلاب للسلامة. تصميم الشبكة الباردة الملمس يمنع الحروق العرضية مع توفير دفء فعال. الهيكل الخفيف مع قابس أوروبي يجعله مثالياً للاستخدام المنزلي أو المكتبي.',
      category: 'سخان محمول',
      features: ['حماية من الانقلاب', 'شبكة باردة الملمس', 'تصميم مدمج', 'تسخين سريع', 'فعال في استهلاك الطاقة'],
      specs: [
        { label: 'الموديل', value: 'JHL020A' },
        { label: 'اسم المنتج', value: 'سخان تحت الطاولة' },
        { label: 'الجهد', value: '220-240V~50Hz' },
        { label: 'القدرة', value: '1200W' },
        { label: 'التحكم', value: 'مفتاح تبديل' },
        { label: 'عنصر التسخين', value: 'أنبوب تسخين من الألياف الكربونية x 1' },
        { label: 'القابس', value: 'قابس أوروبي' },
        { label: 'الكابل', value: '1.8-1.9m' },
        { label: 'المادة', value: 'حديد، ألومنيوم' }
      ]
    },
    p10: {
      name: 'JHL023',
      description: 'سخان ألياف كربونية قوي مع إعدادين حراريين ومقبض قابل للطي. حل تدفئة محمول لأي مساحة.',
      longDescription:
        'JHL023 هو سخان أرضي قوي ومحمول يتميز بأنبوبين من الألياف الكربونية لتوفير دفء فعال. إعدادات حرارية متعددة (750W + 750W) تسمح بالتحكم المرن في درجة الحرارة. يوفر المفتاف الدواري تشغيلاً سهلاً، بينما يجعل المقبض القابل للطي قابلية عالية للحمل. مصنوع من البلاستيك والفولاذ المتين، هذا السخان مثالي لغرف المعيشة وغرف النوم والمكاتب أو أي مساحة تحتاج إلى دفء إضافي.',
      category: 'سخان محمول',
      features: ['إعدادات حرارية مزدوجة', 'مقبض قابل للطي', 'تدفئة بالألياف الكربونية', 'تصميم محمول', 'تشغيل سهل'],
      specs: [
        { label: 'الموديل', value: 'JHL023' },
        { label: 'اسم المنتج', value: 'سخان أرضي' },
        { label: 'الجهد', value: '220-240V~50Hz' },
        { label: 'القدرة', value: '1500W (الحد الأقصى)' },
        { label: 'الإعدادات', value: '750W + 750W' },
        { label: 'التحكم', value: 'مفتاح دوار' },
        { label: 'عنصر التسخين', value: 'أنبوب تسخين من الألياف الكربونية x 2' },
        { label: 'القابس', value: 'قابس أوروبي' },
        { label: 'الكابل', value: '1.8-1.9m' },
        { label: 'المادة', value: 'بلاستيك، فولاذ' },
        { label: 'الميزة', value: 'مقبض قابل للطي' }
      ]
    },
    p11: {
      name: 'JHL023-05',
      description: 'سخان ألياف كربونية مدمج مع إعدادين حراريين. تدفئة فعالة في استهلاك الطاقة للمساحات الصغيرة والمتوسطة.',
      longDescription:
        'JHL023-05 هو سخان أرضي مدمج وفعال في استهلاك الطاقة مثالي للمساحات الصغيرة والمتوسطة. يتميز بأنبوبين من الألياف الكربونية مع إعدادين قابلين للتعديل (400W + 400W)، يوفر دفئاً مريحاً مع توفير الطاقة. يسمح المفتاف الدواري بالتشغيل السهل، ويضمن المقبض القابل للطي سهولة التخزين والحمل. مثالي لغرف النوم والمكاتب المنزلية أو مساحات العمل الشخصية.',
      category: 'سخان محمول',
      features: ['إعدادين حراريين', 'مقبض قابل للطي', 'تدفئة بالألياف الكربونية', 'مدمج ومحمول', 'فعال في استهلاك الطاقة'],
      specs: [
        { label: 'الموديل', value: 'JHL023-05' },
        { label: 'اسم المنتج', value: 'سخان أرضي' },
        { label: 'الجهد', value: '220-240V~50Hz' },
        { label: 'القدرة', value: '800W (الحد الأقصى)' },
        { label: 'الإعدادات', value: '400W + 400W' },
        { label: 'التحكم', value: 'مفتاح دوار' },
        { label: 'عنصر التسخين', value: 'أنبوب تسخين من الألياف الكربونية x 2' },
        { label: 'القابس', value: 'قابس أوروبي' },
        { label: 'الكابل', value: '1.8-1.9m' },
        { label: 'المادة', value: 'بلاستيك، فولاذ' },
        { label: 'الميزة', value: 'مقبض قابل للطي' }
      ]
    },
    p12: {
      name: 'JHL021-S',
      description: 'سخان متعدد الوظائف مع إضاءة LED وسماعة بلوتوث. مثالي لخلق جو مريح.',
      longDescription:
        'JHL021-S هو سخان مبتكر يجمع بين وظيفة التدفئة وميزات الترفيه. يتميز بإضاءة LED بـ 16 لوناً لخلق الجو المثالي لأي بيئة. مجهز بسماعة بلوتوث لبث الموسيقى من جهازك المحمول. يتحكم مفتاح التبديل في إعدادات الحرارة، بينما يتحكم جهاز التحكم عن بعد في وظائف البلوتوث والإضاءة. يتميز بحماية من الانقلاب للسلامة وشبكة باردة الملمس لمنع الحروق. أنبوب تسخين من الألياف الكربونية يوفر تدفئة فعالة وسريعة. مثالي لغرف المعيشة وغرف النوم أو أي مساحة داخلية حيث تريد الدفء والأجواء المريحة.',
      category: 'سخان محمول',
      features: ['إضاءة LED بـ 16 لوناً', 'سماعة بلوتوث', 'حماية من الانقلاب', 'شبكة باردة الملمس', 'تحكم عن بعد'],
      specs: [
        { label: 'الموديل', value: 'JHL021-S' },
        { label: 'اسم المنتج', value: 'سخان LED مع بلوتوث' },
        { label: 'الجهد', value: '220-240V~50Hz' },
        { label: 'القدرة', value: '1500W' },
        { label: 'التحكم', value: 'مفتاح تبديل (حرارة)، جهاز تحكم عن بعد (بلوتوث وLED)' },
        { label: 'LED', value: 'إضاءة بـ 16 لوناً' },
        { label: 'عنصر التسخين', value: 'أنبوب تسخين من الألياف الكربونية x 1' },
        { label: 'القابس', value: 'قابس أوروبي' },
        { label: 'الكابل', value: '1.8-1.9m' },
        { label: 'السلامة', value: 'حماية من الانقلاب، شبكة باردة الملمس' },
        { label: 'المادة', value: 'حديد، ألومنيوم' }
      ]
    },
    p13: {
      name: 'JHL004-B',
      description: 'سخان هالوجيني قوي 3000 واط مع قابل للتعديل. ارتفاع قابل للتخصيص لتغطية تدفئة مخصصة.',
      longDescription:
        'JHL004-B هو سخان أرضي قوي للباحات مصمم للمساحات الخارجية وشبه الخارجية. يتميز بأنبوبين تسخين هالوجينيين يوفران دفئاً مريحاً وفعالاً مع ثلاث إعدادات طاقة قابلة للتعديل (1200W-1800W-3000W). يسمح القطب القابل للتعديل بارتفاع من 1.6 متر إلى 2.08 متر، مما يتيح تغطية تدفئة مخصصة للمناطق المختلفة. مجهز بكل من جهاز التحكم عن بعد وزر اللمس للتشغيل المريح. يتميز بحماية من الانقلاب للسلامة. يضمن التصميم الحديث مع هيكل حديد وألومنيوم المتانة مع الحفاظ على مظهر أنيق. مثالي للباحات والحدائق ومناطق الترفيه الخارجية.',
      category: 'سخان محمول',
      features: ['قدرة عالية 3000W', 'قطب قابل للتعديل', '3 إعدادات حرارة', 'تحكم عن بعد ولمس', 'حماية من الانقلاب'],
      specs: [
        { label: 'الموديل', value: 'JHL004-B' },
        { label: 'اسم المنتج', value: 'سخان أرضي للباحات' },
        { label: 'الجهد', value: '220-240V~50Hz' },
        { label: 'القدرة', value: '3000W (الحد الأقصى)' },
        { label: 'الإعدادات', value: '1200W-1800W-3000W' },
        { label: 'التحكم', value: 'جهاز تحكم عن بعد وزر لمس' },
        { label: 'الارتفاع', value: 'قطب قابل للتعديل (1.6m - 2.08m)' },
        { label: 'عنصر التسخين', value: 'أنبوب تسخين هالوجيني x 2' },
        { label: 'القابس', value: 'قابس أوروبي' },
        { label: 'الكابل', value: '1.8-1.9m' },
        { label: 'السلامة', value: 'حماية من الانقلاب' },
        { label: 'المادة', value: 'حديد، ألومنيوم' }
      ]
    },
    p14: {
      name: 'JHL001-BZ',
      description: 'سخان هالوجيني فعال للباحات بتصميم عمود ثابت. حل تدفئة أنيق ونظيف للمساحات الخارجية.',
      longDescription:
        'JHL001-BZ هو سخان باحات أنيق وفعال يتميز بتصميم عمود ثابت. مجهز بأنبوبين تسخين هالوجينيين يوفران ثلاث إعدادات طاقة قابلة للتعديل (900W-1200W-2100W) لدفء مريح. يضيف التصميم المغطى بالقماش لمسة أنيقة مع الحفاظ على الوظائف. يسمح كل من جهاز التحكم عن بعد وزر اللمس بالتشغيل السهل. يتميز بحماية من الانقلاب للاستخدام الآمن. يضمن مزيج مواد الحديد والألومنيوم المتانة وتوزيع الحرارة الفعال. مثالي للباحات المغطاة والمظلات والمساحات الخارجية شبه الأخرى حيث الأسلوب والدفء متساويان في الأهمية.',
      category: 'سخان محمول',
      features: ['3 إعدادات حرارة', 'تصميم قماشي', 'تحكم عن بعد ولمس', 'حماية من الانقلاب', 'تدفئة هالوجينية فعالة'],
      specs: [
        { label: 'الموديل', value: 'JHL001-BZ' },
        { label: 'اسم المنتج', value: 'سخان قماشي للباحات' },
        { label: 'الجهد', value: '220-240V~50Hz' },
        { label: 'القدرة', value: '2100W (الحد الأقصى)' },
        { label: 'الإعدادات', value: '900W-1200W-2100W' },
        { label: 'التحكم', value: 'جهاز تحكم عن بعد وزر لمس' },
        { label: 'الارتفاع', value: 'عمود ثابت' },
        { label: 'عنصر التسخين', value: 'أنبوب تسخين هالوجيني x 2' },
        { label: 'القابس', value: 'قابس أوروبي' },
        { label: 'الكابل', value: '1.8-1.9m' },
        { label: 'السلامة', value: 'حماية من الانقلاب' },
        { label: 'المادة', value: 'حديد، ألومنيوم' }
      ]
    },
    p15: {
      name: 'JHD028-B',
      description: 'سخان هالوجيني قوي 2000 واط مركب على السقف مع 3 إعدادات حرارة. مثالي للمساحات الداخلية ذات الأسقف العالية.',
      longDescription:
        'JHD028-B هو سخان مركب على السقف مصمم لتدفئة فعالة في المساحات الداخلية. يتميز بأنبوبين تسخين هالوجينيين يوفران تدفئة قوية ومتساوية مع ثلاث إعدادات قابلة للتعديل (800W-1200W-2000W). يوفر التركيب على السقف مساحة أرضية ممتازة بينما يوفر توزيع حرارة ممتازاً من الأعلى. مجهز بكل من جهاز التحكم عن بعد وزر اللمس للتشغيل المريح. يضمن هيكل الألومنيوم والحديد المتانة والتوصيل الحراري الفعال. مثالي للغرف ذات الأسقف العالية والجراجات وورش العمل أو أي مساحة يفضل فيها التركيب على السقف. يوفر دفئاً مريحاً ومتساوياً دون شغل مساحة أرضية.',
      category: 'سخان محمول',
      features: ['تركيب على السقف', '2 أنابيب هالوجينية', '3 إعدادات حرارة', 'تحكم عن بعد ولمس', 'توفير المساحة'],
      specs: [
        { label: 'الموديل', value: 'JHD028-B' },
        { label: 'اسم المنتج', value: 'سخان سقفي' },
        { label: 'الجهد', value: '220-240V~50Hz' },
        { label: 'القدرة', value: '2000W (الحد الأقصى)' },
        { label: 'الإعدادات', value: '800W-1200W-2000W' },
        { label: 'التحكم', value: 'جهاز تحكم عن بعد وزر لمس' },
        { label: 'عنصر التسخين', value: 'أنبوب تسخين هالوجيني x 2' },
        { label: 'القابس', value: 'قابس أوروبي' },
        { label: 'الكابل', value: '1.8-1.9m' },
        { label: 'المادة', value: 'ألومنيوم، حديد' }
      ]
    },
    p16: {
      name: 'JHG019-B',
      description: 'سخان ذكي بالكربون مع وظيفة المؤقت. التصميم المثبت على الحائط يوفر مساحة بينما يوفر دفئاً قوياً.',
      longDescription:
        'JHG019-B هو سخان باحات ذكي مثبت على الحائط يتميز بتكنولوجيا تسخين متقدمة بالألياف الكربونية. يوفر دفئاً قوياً وفعالاً مع ثلاث إعدادات قابلة للتعديل (650W-1300W-2000W). يتميز بخيارات تحكم متعددة بما في ذلك مفتاح تبديل وجهاز تحكم عن بعد وزر لمسة لراحة قصوى. تتيح وظيفة المؤقت المدمج الإيقاف التلقائي حتى 8 ساعات، مما يوفر الطاقة ويمنح راحة البال. أنبوب التسخين الكربوني يضمن تسخيناً سريعاً مع توزيع حرارة ممتاز. يوفر التصميم المثبت على الحائط مساحة أرضية ثمينة بينما يوفر دفئاً قوياً. مصنوع من هيكل حديد وألومنيوم متين. مثالي للباحات والجراجات والأوراق العمل أو أي مساحة داخلية/خارجية يفضل فيها التركيب على الحائط.',
      category: 'سخان محمول',
      features: ['تركيب على الحائط', 'تدفئة كربونية', 'مؤقت حتى 8 ساعات', 'خيارات تحكم متعددة', 'تصميم توفير المساحة'],
      specs: [
        { label: 'الموديل', value: 'JHG019-B' },
        { label: 'اسم المنتج', value: 'سخان باحات مثبت على الحائط' },
        { label: 'الجهد', value: '220-240V~50Hz' },
        { label: 'القدرة', value: '2000W (الحد الأقصى)' },
        { label: 'الإعدادات', value: '650W-1300W-2000W' },
        { label: 'المفتاح', value: 'مفتاح تبديل، جهاز تحكم عن بعد وتحكم باللمس' },
        { label: 'جهاز التحكم عن بعد', value: 'نعم' },
        { label: 'المؤقت', value: 'نعم، حتى 8 ساعات' },
        { label: 'عنصر التسخين', value: 'أنبوب تسخين كربوني' },
        { label: 'القابس', value: 'قابس أوروبي' },
        { label: 'الكابل', value: '1.8-1.9m' },
        { label: 'المادة', value: 'حديد، ألومنيوم' }
      ]
    },
    p17: {
      name: 'JH-104',
      description: 'سخان فعال مثبت على الحائط مع أنبوب تسخين هالوجيني ذهبي أحمر. تصميم مدمج مثالي للمساحات الداخلية.',
      longDescription:
        'JH-104 هو سخان فعال مثبت على الحائط مصمم للمساحات الداخلية. يتميز بأنبوب تسخين هالوجيني ذهبي أحمر يوفر تسخيناً سريعاً وفعالاً. التصميم المدمج مع ثلاث إعدادات حرارة قابلة للتعديل (800W/1300W/2000W) يتيح لك تخصيص مستوى الراحة الخاص بك. مجهز بتحكم عن بعد للتشغيل المريح. التصميم الأنيق يناسب أي غرفة تماماً بينما يوفر دفئاً قوياً. مثالي لغرف المعيشة وغرف النوم والمكاتب أو أي مساحة داخلية يفضل فيها التركيب على الحائط.',
      category: 'سخان محمول',
      features: ['تركيب على الحائط', 'أنبوب هالوجيني ذهبي أحمر', '3 إعدادات حرارة', 'تحكم عن بعد', 'تصميم مدمج'],
      specs: [
        { label: 'الموديل', value: 'JH-104' },
        { label: 'اسم المنتج', value: 'سخان مثبت على الحائط' },
        { label: 'الجهد', value: '220V ~ 50Hz' },
        { label: 'القدرة', value: '2000W (الحد الأقصى)' },
        { label: 'الإعدادات', value: '800W / 1300W / 2000W' },
        { label: 'التحكم', value: 'تحكم عن بعد' },
        { label: 'عنصر التسخين', value: 'أنبوب تسخين هالوجيني ذهبي أحمر' },
        { label: 'القابس', value: 'قابس أوروبي' },
        { label: 'الكابل', value: '3m' },
        { label: 'الأبعاد', value: '63.5cm × 10cm' },
        { label: 'الوزن', value: '2.2kg' }
      ]
    },
    p18: {
      name: 'JH-106',
      description: 'سخان مدمج مثبت على السقف بتقنية الألياف الكربونية. مثالي للمساحات الداخلية الصغيرة.',
      longDescription:
        'JH-106 هو سخان مدمج مثبت على السقف مصمم لتدفئة فعالة في المساحات الداخلية الصغيرة. يتميز بتكنولوجيا أنبوب التسخين من الألياف الكربونية لتسخين سريع وفعال. يوفر مفتاح السحب سهل للتحكم في التشغيل. ثلاث إعدادات حرارة قابلة للتعديل (600W/1000W/1500W) تتيح لك تخصيص مستوى الراحة الخاص بك. يوفر التركيب على السقف مساحة أرضية بينما يوفر توزيع حرارة ممتازاً. مثالي للغرف الصغيرة والحمارات والمطابخ أو أي مساحة يفضل فيها التركيب على السقف.',
      category: 'سخان محمول',
      features: ['تركيب على السقف', 'تقنية الألياف الكربونية', '3 إعدادات حرارة', 'مفتاح سحب', 'توفير المساحة'],
      specs: [
        { label: 'الموديل', value: 'JH-106' },
        { label: 'اسم المنتج', value: 'سخان سقفي' },
        { label: 'الجهد', value: '220V ~ 50Hz' },
        { label: 'القدرة', value: '1500W (الحد الأقصى)' },
        { label: 'الإعدادات', value: '600W / 1000W / 1500W' },
        { label: 'التحكم', value: 'مفتاح سحب' },
        { label: 'عنصر التسخين', value: 'أنبوب تسخين من الألياف الكربونية' },
        { label: 'القابس', value: 'قابس أوروبي' },
        { label: 'الكابل', value: '3m' },
        { label: 'الأبعاد', value: '42cm (قطر) × 30cm (ارتفاع)' },
        { label: 'الوزن', value: '2.3kg' }
      ]
    },
    p19: {
      name: 'JH-3000',
      description: 'سخان باحات قابل للتعديل مع تحكم بتطبيق الهاتف الذكي. مثترفيه فيالي لل الهواء الطلق.',
      longDescription:
        'JH-3000 هو سخان باحات قابل للتعديل مصمم للترفيه في الهواء الطلق. يتميز بتكنولوجيا أنبوب التسخين المتقدمة من الألياف الكربونية لتدفئة قوية وفعالة. الارتفاع القابل للتعديل (160-205cm) يتيح لك تخصيص تغطية التدفئة. مجهز بتحكم عن بعد وتطبيق الهاتف الذكي لراحة قصوى. ثلاث إعدادات حرارة قابلة للتعديل (1200W/1800W/3000W) توفر راحة قابلة للتخصيص. القاعدة المتينة بقطر 45cm تضمن الثبات. مثالي للباحات والشرفات والحدائق ومناطق الترفيه في الهواء الطلق.',
      category: 'سخان محمول',
      features: ['ارتفاع قابل للتعديل', 'تدفئة بالألياف الكربونية', '3 إعدادات حرارة', 'تحكم بتطبيق الهاتف الذكي', 'تحكم عن بعد'],
      specs: [
        { label: 'الموديل', value: 'JH-3000' },
        { label: 'اسم المنتج', value: 'سخان باحات أسود قابل للتعديل' },
        { label: 'الجهد', value: '220V ~ 50Hz' },
        { label: 'القدرة', value: '3000W (الحد الأقصى)' },
        { label: 'الإعدادات', value: '1200W / 1800W / 3000W' },
        { label: 'التحكم', value: 'تحكم عن بعد وتطبيق الهاتف الذكي' },
        { label: 'عنصر التسخين', value: 'أنبوب تسخين من الألياف الكربونية' },
        { label: 'القابس', value: 'قابس أوروبي' },
        { label: 'الكابل', value: '5m' },
        { label: 'الارتفاع', value: 'قابل للتعديل، 160-205cm' },
        { label: 'قطر القاعدة', value: '45cm' },
        { label: 'الوزن', value: '12kg' }
      ]
    },
  },
};
